export default "__VITE_ASSET__CvLmePtm__"